import styled from "styled-components";

export const VoucherCardFaceCurrentAmountBox = styled.span`
    font-family: ${props => props.theme.font.family.bold};
    padding-left: 4px;
`